import React from "react";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import { ExternalLink } from "components/link";
import { FormattedMessage } from "react-intl";
import { PaginatedTable } from "components/table";
import PropTypes from "prop-types";
import { HeaderCell } from "components/table";
import { Restricted, permissions } from "components/auth";
import Chip from "components/chip";
import { injectIntl } from "react-intl";
import withStyles from "components/with-styles";
import styles from "./styles/started-recording-table.css.js";

const Header = () => (
  <TableRow>
    <HeaderCell>
      <FormattedMessage id="common.name" />
    </HeaderCell>
    <Restricted permissions={[permissions.admin_view]}>
      <HeaderCell>
        <FormattedMessage id="common.url" />
      </HeaderCell>
    </Restricted>
  </TableRow>
);

const RowComponent = ({ item, classes, intl }) => {
  return item ? (
    <TableRow>
      <TableCell>
        <div>{item.description}</div>
        {item.status === "running" && (
          <div>
            <Chip
              className={classes.status}
              variant="outlined"
              label={intl.formatMessage({ id: "event.startedRecording.running" })}
            />
          </div>
        )}
      </TableCell>
      <Restricted permissions={[permissions.admin_view]}>
        <TableCell>
          <ExternalLink href={item.url}>{item.url}</ExternalLink>
        </TableCell>
      </Restricted>
    </TableRow>
  ) : null;
};

RowComponent.propTypes = {
  /**
   ** Elemento a representar en la fila de la tabla
   **/
  item: PropTypes.object,
};

const Row = withStyles(styles)(injectIntl(RowComponent));

const StartedRecordingTable = ({ event, ...props }) => {
  const recordings = event && event.infoBert && event.infoBert.recordingList;

  return (
    <PaginatedTable
      getItemKey={item => item && item.url}
      paginatedElements={{ items: recordings || [], total: recordings ? recordings.length : 0 }}
      headerComponent={Header}
      rowComponent={Row}
      showPagination={false}
      perPage={0}
    />
  );
};

StartedRecordingTable.propTypes = {
  /**
   ** Evento del que se mostrarán las grabaciones en activo
   **/
  event: PropTypes.object,
  /**
   ** Componente que se mostrará en el pie de la tabla
   **/
  footer: PropTypes.element,
};

export default StartedRecordingTable;
